import { Alert, Button } from "@mui/material";

export const SERIAL_VERIFICATION_MESSAGE =
  "Check this serial before cleaning or resale. Blancco wrote a serial that already belongs to another inventory.";

export function SerialVerificationNotice({
  required,
  confirming,
  onConfirm,
}: {
  required?: boolean;
  confirming?: boolean;
  onConfirm: () => void;
}) {
  if (!required) return null;

  return (
    <Alert
      severity="warning"
      sx={{ mb: 2 }}
      action={
        <Button type="button" color="inherit" size="small" onClick={onConfirm} disabled={confirming}>
          Serial checked
        </Button>
      }
    >
      {SERIAL_VERIFICATION_MESSAGE}
    </Alert>
  );
}
